import {duration} from './mute';
export default function(selection) {
  selection.transition().duration(duration).attr('opacity', 1);
  return this;
}


// WEBPACK FOOTER //
// ./layouts/default/demute.js